export default __webpack_public_path__ + "static/Tek_Helmet-79e03674faada5184ea3d0656ee1c354.png";